import { Rule } from "antd/lib/form"
import i18n from "~Shared/locales/i18n"
import { isURL } from "~Shared/utils/plugins/draftjs/utils"
import validateEmail from "~Shared/validators/email.validator"

export const createSsoRules = () => ({
    domain: [
        {
            required: true,
            validator: (_rule, value: string) => {
                if (!value) {
                    return Promise.reject(new Error(i18n.t("validation:required")))
                }

                if (validateEmail(value)) {
                    return Promise.reject(new Error(i18n.t("validation:sso_domain_can_not_be_an_email")))
                }

                if (!isURL(value)) {
                    return Promise.reject(new Error(i18n.t("validation:url")))
                }

                return Promise.resolve()
            },
        },
    ] as Array<Rule>,
    clientId: [
        {
            required: true,
            message: i18n.t("validation:required"),
        },
    ] as Array<Rule>,
    clientSecret: [
        {
            required: true,
            message: i18n.t("validation:required"),
        },
    ] as Array<Rule>,
})
